import React from 'react';
import Page from "../../containers/Page/Page";
import { Typography, TableContainer, Table, TableHead, TableCell, TableRow, TableBody } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { api } from '../../services/api';
import { Helpers } from '../../utils/Helpers';

interface IVariante {
    tipo_variante: string;
}

function PrecosVariantes() {

    const history = useHistory();

    const [error, setError] = React.useState<string>('');
    const [loading, setLoading] = React.useState<boolean>(false);
    const [variantes, setVariantes] = React.useState<IVariante[]>([]);

    /**
     * Ao carregar a página.
     */
    React.useEffect(() => {
        handleFetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Carregar variantes.
     * @param page 
     */
    async function handleFetch() {
        setLoading(true);
        try {
            const response = await api.get('especiais/SIMPLES');
            setVariantes(response.data.object);
            setError('');
        } catch (error: any) {
            setError(Helpers.errorFormat(error));
        }
        setLoading(false);
    }

    return (
        <Page error={error} loading={loading}>
            <Page.Title>
                <Typography variant="h6" component="div">
                    Acessórios Variantes
                </Typography>
            </Page.Title>
            {variantes &&
                <Page.Section>
                    <Page.Content>
                        <TableContainer>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Acessório</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {variantes.map((variante, index) => (
                                        <TableRow
                                            key={index}
                                            hover={true}
                                            onClick={() => history.push(`/precos/variantes/${encodeURI(variante.tipo_variante)}`)}
                                        >
                                            <TableCell>{variante.tipo_variante}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Page.Content>
                </Page.Section>
            }
        </Page >
    );
}

export default PrecosVariantes;